<template>
    <div>
        <Button outlined :secondary="!running" :primary="running" @click="handleToggle">
            <Icon fixedWidth :icon="running ? 'volume-xmark' : 'volume'" fixed-width />
        </Button>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import {installAudioUnlockListeners, playTone, unlockAudioContext} from '@/utils/audio';

export default defineComponent({
  name: 'Metronome',
  mounted() {
    installAudioUnlockListeners();
  },
  beforeUnmount() {
    this.stopMetronome();
  },
  computed: {
    label() {
      return this.running ? 'Stop Metronome' : 'Start Metronome';
    },
  },
  data() {
    return {
      beat: 0,
      interval: null,
      running: false,
    };
  },
  methods: {
    handleToggle() {
      if (this.running) {
        this.stopMetronome();
        return;
      }

      this.startMetronome();
    },
    playBeat() {
      const pattern = Number(this.pattern || 1);
      const beatNumber = this.beat + 1;
      const accented = pattern > 1 && beatNumber % pattern === 0;

      playTone({
        attack: 0.005,
        duration: accented ? 0.11 : 0.08,
        frequency: accented ? 1040 : 760,
        type: 'triangle',
        volume: accented ? 0.18 : 0.14,
      });

      this.beat += 1;
    },
    startMetronome() {
      unlockAudioContext();
      this.beat = 0;
      this.running = true;
      this.playBeat();
      this.interval = setInterval(this.playBeat, 1000);
    },
    stopMetronome() {
      this.running = false;

      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
  },
  props: {
    pattern: {
      default: 1,
      required: false,
      type: Number,
    },
  },
});
</script>

<style scoped lang="scss">

</style>
